import DeepSpeech from './components/DeepSpeech';

export default DeepSpeech;
